import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { NumberBadgeComponent } from './number-badge.component';

@NgModule({
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		NgxSkeletonLoaderModule
	],
	declarations: [NumberBadgeComponent],
	exports: [NumberBadgeComponent]
})
export class NumberBadgeModule { }
